import { useMemo } from 'react';
import { formatNumberWithSpaces } from '../../utils/campaignHelpers';

export const usePrizeFundFormatting = (amount: string | number) => {
  const formattedAmount = useMemo(() => {
    return formatNumberWithSpaces(amount.toString());
  }, [amount]);

  return {
    formattedAmount,
  };
};
